import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";
import { ARTISTS } from "../data/artistas";
import { useLanguage } from "../i18n/LanguageContext";

export const Artistas = () => {
    const { t } = useLanguage();
    return (
        <section id="artistas" className="py-14 sm:py-16" data-testid="artistas-section">
            <div className="mx-auto max-w-[1500px] px-5 sm:px-10">
                <Reveal>
                    <div className="flex items-center justify-center gap-4 sm:gap-5">
                        <span className="hidden sm:block h-px flex-1 max-w-56 bg-gradient-to-l from-[#c9a24b]/60 to-transparent" />
                        <span className="hidden sm:block w-1.5 h-1.5 rotate-45 border border-[#c9a24b]" />
                        <h2 className="font-caps gold-text text-lg sm:text-xl tracking-[0.2em] text-center" data-testid="artistas-title">
                            {t.artistas.titulo}
                        </h2>
                        <span className="hidden sm:block w-1.5 h-1.5 rotate-45 border border-[#c9a24b]" />
                        <span className="hidden sm:block h-px flex-1 max-w-56 bg-gradient-to-r from-[#c9a24b]/60 to-transparent" />
                    </div>
                    <div className="flex justify-center mt-2">
                        <img loading="lazy" decoding="async" src="/images/ornamento.webp" alt="" aria-hidden="true" className="w-44 opacity-90" />
                    </div>
                </Reveal>

                <div className="mt-12 grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
                    {ARTISTS.map((a, i) => (
                        <Reveal key={a.slug} delay={i * 0.08} className="h-full">
                            <Link
                                to={`/artistas/${a.slug}`}
                                className="group relative block overflow-hidden aspect-[3/4] shadow-[0_20px_60px_rgba(0,0,0,0.6)] hover:shadow-[0_25px_70px_rgba(201,162,75,0.12)] hover:-translate-y-1 transition-all duration-500 h-full"
                                data-testid={`artist-card-${a.slug}`}
                                aria-label={`Página de ${a.name}`}
                            >
                                <img loading="lazy" decoding="async"
                                    src={a.image}
                                    alt={a.name}
                                    className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                                    data-testid={`artist-image-${a.slug}`}
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#070503] via-[#070503]/30 to-transparent" />
                                <div className="absolute inset-x-0 bottom-0 p-5 sm:p-6 text-center">
                                    <h3 className="font-caps gold-text text-sm sm:text-base tracking-[0.12em] uppercase leading-snug">{a.name}</h3>
                                    <p className="font-caps text-[9px] sm:text-[10px] tracking-[0.3em] uppercase text-[#efe6d6]/75 mt-1.5">
                                        {t.artists[a.slug]?.role || a.role}
                                    </p>
                                </div>
                            </Link>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
